// extracted by mini-css-extract-plugin
export var active = "_fp-2";
export var recordingDot = "_fp-1";
export var recordingIndicator = "_fp-0";